import Service from "./apiService";

class LiveService extends Service {
  getData() {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `lives`,
      method: "GET",
    });
  }

  get(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `live/${id}`,
      method: "GET",
    });
  }  

  add(form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `live`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  update(id, form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `live/${id}`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  delete(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `live/${id}`,
      method: "DELETE",
    });
  }

}

export var liveService = new LiveService();
